(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    // --- Tags modal logic ---
    const modal = document.getElementById('CdTagsModal');
    const openButtons = document.querySelectorAll('[data-cd-open-tags]');
    if (modal) {
      const closeButtons = modal.querySelectorAll('[data-cd-close-tags]');
      let lastFocused = null;

      const focusableSelector = [
        'a[href]',
        'button:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',');

      function openModal() {
        lastFocused = document.activeElement;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';

        const first = modal.querySelector(focusableSelector);
        if (first) first.focus({ preventScroll: true });
      }

      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      }

      openButtons.forEach(btn => btn.addEventListener('click', openModal));
      closeButtons.forEach(btn => btn.addEventListener('click', closeModal));

      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
          return;
        }

        if (e.key === 'Tab') {
          const focusables = Array.from(modal.querySelectorAll(focusableSelector))
            .filter(el => el.offsetParent !== null);
          if (!focusables.length) return;

          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
